export function OnboardImage4() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 390 409' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M297.657 90.0962H95.9674M95.9674 90.0962H92.2115V96.1075H85.0754V100.616H79.066V106.627H73.4322V113.014H67.4228V238.125H78.6904M95.9674 90.0962V208.82M95.9674 208.82H181.977M95.9674 208.82V215.583H90.3336V221.594H84.6998V227.229H78.6904V238.125M194.371 313.642V208.82H181.977M194.371 313.642H319.441M194.371 313.642V318.902H188.362V324.913H181.226V330.173H176.343V342.196M319.441 313.642V113.014M319.441 313.642V318.902H313.432V324.913H308.174V330.173H301.789V336.56H296.155V342.196M297.657 342.196H296.155M164.324 238.125V342.196H176.343M164.324 238.125V232.489H171.085V226.102H175.592V220.842H181.977V208.82M164.324 238.125H78.6904M296.155 342.196H176.343'
        stroke='var(--black)'
        strokeWidth='3.76304'
      />
      <rect x='299.536' y='92.7269' width='5.25678' height='4.5073' fill='var(--black)' strokeWidth='0.752608' />
      <rect x='305.545' y='98.7386' width='5.25678' height='4.5073' fill='var(--black)' strokeWidth='0.752608' />
      <rect x='310.804' y='103.998' width='5.25678' height='4.5073' fill='var(--black)' strokeWidth='0.752608' />
      <path
        d='M299.16 91.9746C233.182 92.2251 99.6481 91.9746 97.8453 91.9746V206.941H196.249V311.764L316.437 311.012L317.563 112.639L316.437 108.881H310.427V103.622H305.31V98.3616L305.169 97.6102H302.164H299.16V94.6046V91.9746Z'
        fill='#391998'
        stroke='var(--black)'
        strokeWidth='0.752608'
      />
      <rect
        x='113.834'
        y='137.166'
        width='28.5991'
        height='6.02086'
        transform='rotate(-90 113.834 137.166)'
        fill='white'
      />
      <rect
        x='123.855'
        y='137.166'
        width='28.5991'
        height='6.02086'
        transform='rotate(-90 123.855 137.166)'
        fill='white'
      />
      <rect
        x='141.165'
        y='137.166'
        width='28.5991'
        height='6.02086'
        transform='rotate(-90 141.165 137.166)'
        fill='white'
      />
      <rect
        x='135.144'
        y='125.125'
        width='5.26826'
        height='6.02086'
        transform='rotate(-90 135.144 125.125)'
        fill='white'
      />
      <rect
        x='129.123'
        y='119.104'
        width='5.26826'
        height='6.02086'
        transform='rotate(-90 129.123 119.104)'
        fill='white'
      />
      <rect x='155.322' y='108.866' width='15.9091' height='4.13636' fill='white' />
      <rect x='155.322' y='120.957' width='12.4091' height='4.13636' fill='white' />
      <rect x='151.504' y='132.73' width='16.2273' height='4.13636' fill='white' />
      <rect x='167.413' y='125.093' width='4.13636' height='7.63636' fill='white' />
      <rect x='151.186' y='112.685' width='4.45455' height='8.27273' fill='white' />
      <rect x='175.549' y='108.867' width='20.3636' height='4.13636' fill='white' />
      <rect x='183.504' y='113.003' width='4.77273' height='23.8636' fill='white' />
      <rect x='205.657' y='108.866' width='10.7693' height='5.74362' fill='white' />
      <rect x='205.657' y='120.354' width='11.4872' height='5.74362' fill='white' />
      <rect
        x='217.144'
        y='136.866'
        width='22.2565'
        height='5.74362'
        transform='rotate(-90 217.144 136.866)'
        fill='white'
      />
      <rect
        x='199.913'
        y='136.866'
        width='22.2565'
        height='5.74362'
        transform='rotate(-90 199.913 136.866)'
        fill='white'
      />
      <rect x='226.887' y='108.866' width='5' height='28' fill='white' />
      <rect x='231.887' y='131.866' width='14' height='5' fill='white' />
      <rect x='249.887' y='108.866' width='5' height='28' fill='white' />
      <rect x='254.887' y='131.866' width='14' height='5' fill='white' />
      <path
        d='M219.318 280.527C220.043 280.546 220.631 281.128 220.654 281.857L220.898 289.806C220.925 290.659 221.336 291.454 222.017 291.969L226.502 295.362C226.745 295.546 227.041 295.645 227.346 295.645C230.019 295.645 231.776 292.854 230.618 290.446L222.408 273.362C221.83 272.159 220.714 271.309 219.318 271.309C217.991 271.309 216.805 272.159 216.227 273.362L208.017 290.446C206.86 292.854 208.616 295.645 211.29 295.645C211.594 295.645 211.89 295.546 212.133 295.362L216.619 291.969C217.3 291.454 217.711 290.659 217.737 289.806L217.982 281.857C218.004 281.128 218.592 280.546 219.318 280.527Z'
        fill='white'
      />
      <path
        d='M94.0895 213.704V97.9863H86.9533V102.495H80.9439V108.506H75.3101V114.893H69.3008V236.247H76.8125V225.351H82.8219V219.716H88.4557V213.704H94.0895Z'
        fill='#F14317'
        stroke='var(--black)'
        strokeWidth='0.752608'
      />
      <path
        d='M192.493 317.024V210.698H183.855V222.721H177.094V227.981H172.963V234.368H166.202V340.317H174.465V327.919H179.723V323.035H186.859V317.024H192.493Z'
        fill='#F14317'
        stroke='var(--black)'
        strokeWidth='0.752608'
      />
      <path
        d='M180.099 218.964V210.698H97.8453L97.4697 217.461H92.2115V223.472H86.5777V229.108H80.5683V236.246H162.446V230.611H169.207V224.224H174.089V219.34L180.099 218.964Z'
        fill='#6254FC'
        stroke='var(--black)'
        strokeWidth='0.752608'
      />
      <path
        d='M317.564 315.521H196.249L195.873 320.781H190.24V326.792H183.104V332.052H178.221V340.318H294.277V334.682H299.911V328.295H306.296V323.035H311.554V317.024H317.564V315.521Z'
        fill='#6254FC'
        stroke='var(--black)'
        strokeWidth='0.752608'
      />
      <rect x='298.409' y='258.413' width='6.76056' height='28.5538' fill='white' />
      <rect
        x='275.498'
        y='276.072'
        width='6.76274'
        height='6.00939'
        transform='rotate(-90 275.498 276.072)'
        fill='white'
      />
      <rect
        x='275.498'
        y='287.719'
        width='6.76274'
        height='29.2958'
        transform='rotate(-90 275.498 287.719)'
        fill='white'
      />
      <rect
        x='275.498'
        y='298.99'
        width='6.76274'
        height='6.00939'
        transform='rotate(-90 275.498 298.99)'
        fill='white'
      />
      <rect
        x='263.855'
        y='287.719'
        width='6.76274'
        height='6.00939'
        transform='rotate(-90 263.855 287.719)'
        fill='white'
      />
      <rect
        x='269.864'
        y='292.979'
        width='17.2826'
        height='6.00939'
        transform='rotate(-90 269.864 292.979)'
        fill='white'
      />
      <path
        d='M76.3628 58.1454L70.8434 60.623L71.9692 63.1326L68.9586 64.4841L67.8328 61.9744L63.3169 64.0016L64.4428 66.5112L61.4322 67.8627L64.8097 75.3915L67.8202 74.0401L69.1712 77.0517L71.6801 75.9255L72.8059 78.4351L75.3147 77.3089L76.4405 79.8185L78.9494 78.6923L77.8235 76.1827L80.3324 75.0565L79.2065 72.5469L81.7153 71.4207L80.3643 68.4091L83.3749 67.0577L82.4743 65.05L79.4637 66.4014L78.2253 63.6408L75.7164 64.767L74.2529 61.5045L77.2634 60.1531L76.3628 58.1454Z'
        fill='var(--red)'
      />
      <path d='M79.9974 59.5288L81.1233 62.0384L78.6144 63.1646L77.4886 60.655L79.9974 59.5288Z' fill='var(--red)' />
      <rect
        width='3.3'
        height='3.85082'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 74.2529 61.5039)'
        fill='var(--white)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 78.1127 63.3896)'
        fill='var(--white)'
      />
      <g filter='url(#filter0_f_3383_10233)'>
        <rect
          width='4.95'
          height='1.65035'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 63.3169 64.001)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter1_f_3383_10233)'>
        <rect
          width='6.05'
          height='1.65035'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 70.8434 60.6226)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter2_f_3383_10233)'>
        <rect
          width='2.20058'
          height='0.550844'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 79.4831 71.8193)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter3_f_3383_10233)'>
        <rect
          width='2.75'
          height='3.3007'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 76.4726 73.1704)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter4_f_3383_10233)'>
        <rect
          width='2.75'
          height='1.10023'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 75.9902 78.8145)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter5_f_3383_10233)'>
        <rect
          width='2.75'
          height='1.10023'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 72.3556 77.4312)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter6_f_3383_10233)'>
        <rect
          width='2.75'
          height='1.10023'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 68.9461 76.5493)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter7_f_3383_10233)'>
        <rect
          width='2.75'
          height='1.10023'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 80.4158 67.1797)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter8_f_3383_10233)'>
        <rect
          width='3.3'
          height='8.25176'
          transform='matrix(0.912299 -0.409525 0.409306 0.912397 61.4322 67.8623)'
          fill='#A60400'
        />
      </g>
      <rect
        width='6.05'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 69.4924 57.6113)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 76.1376 57.6431)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 67.6077 61.4722)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 60.0812 64.8506)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 64.8097 75.3911)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 68.6695 77.2764)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 72.3042 78.6602)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 76.4406 79.8184)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 77.8235 76.1826)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 79.2065 72.5464)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 80.3643 68.4087)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='8.80188'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 58.4216 69.2139)'
        fill='var(--black)'
      />
      <rect
        width='3.3'
        height='8.80188'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 79.9974 59.5288)'
        fill='var(--black)'
      />
      <rect
        width='6.05'
        height='3.3007'
        transform='matrix(0.912299 -0.409525 0.409306 0.912397 61.4642 61.2148)'
        fill='var(--black)'
      />
      <path
        d='M339.964 56.4418L331.308 54.4968L330.425 58.4326L325.703 57.3717L326.587 53.4359L319.505 51.8446L318.621 55.7803L313.9 54.7194L311.249 66.5265L315.97 67.5874L314.909 72.3103L318.844 73.1944L317.96 77.1301L321.894 78.0142L321.011 81.9499L324.945 82.834L325.829 78.8983L329.763 79.7823L330.647 75.8466L334.582 76.7307L335.642 72.0079L340.363 73.0688L341.071 69.9202L336.349 68.8593L337.321 64.53L333.387 63.6459L334.536 58.5295L339.257 59.5904L339.964 56.4418Z'
        fill='var(--red)'
      />
      <path d='M343.015 61.2616L342.131 65.1973L338.197 64.3133L339.08 60.3775L343.015 61.2616Z' fill='var(--red)' />
      <rect
        width='4.83906'
        height='5.64722'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 334.536 58.5298)'
        fill='var(--white)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 337.41 64.1367)'
        fill='var(--white)'
      />
      <g filter='url(#filter9_f_3383_10233)'>
        <rect
          width='7.25859'
          height='2.42023'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 319.505 51.8447)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter10_f_3383_10233)'>
        <rect
          width='8.87161'
          height='2.42023'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 331.308 54.4971)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter11_f_3383_10233)'>
        <rect
          width='3.22604'
          height='0.806745'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 331.611 75.2368)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter12_f_3383_10233)'>
        <rect
          width='4.03255'
          height='4.84047'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 326.889 74.1758)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter13_f_3383_10233)'>
        <rect
          width='4.03255'
          height='1.61349'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.364 80.3755)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter14_f_3383_10233)'>
        <rect
          width='4.03255'
          height='1.61349'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 318.314 75.5562)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter15_f_3383_10233)'>
        <rect
          width='4.03255'
          height='1.61349'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.086 71.5234)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter16_f_3383_10233)'>
        <rect
          width='4.03255'
          height='1.61349'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 336.783 70.6108)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter17_f_3383_10233)'>
        <rect
          width='4.83906'
          height='12.1012'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 313.9 54.7192)'
          fill='#A60400'
        />
      </g>
      <rect
        width='8.87161'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 332.369 49.7739)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 340.141 55.6548)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 326.764 52.6489)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 314.961 49.9966)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 311.249 66.5264)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 314.123 72.1338)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 317.173 76.9531)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.011 81.9497)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 325.829 78.8984)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 330.647 75.8467)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 335.642 72.0078)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='12.9079'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 309.179 53.6587)'
        fill='var(--black)'
      />
      <rect
        width='4.83906'
        height='12.9079'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 343.015 61.2617)'
        fill='var(--black)'
      />
      <rect
        width='8.87161'
        height='4.84047'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 319.779 46.9453)'
        fill='var(--black)'
      />
      <path
        d='M358.021 195.642L353.586 194.645L353.133 196.662L350.713 196.119L351.166 194.102L347.537 193.286L347.084 195.303L344.665 194.759L343.306 200.81L345.726 201.353L345.182 203.773L347.198 204.227L346.745 206.243L348.762 206.696L348.309 208.713L350.325 209.166L350.778 207.149L352.794 207.602L353.247 205.586L355.263 206.039L355.806 203.619L358.226 204.162L358.588 202.549L356.169 202.005L356.667 199.787L354.651 199.334L355.239 196.712L357.659 197.255L358.021 195.642Z'
        fill='var(--red)'
      />
      <path d='M359.584 198.112L359.131 200.129L357.115 199.676L357.568 197.659L359.584 198.112Z' fill='var(--red)' />
      <rect
        width='2.47967'
        height='2.89379'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 355.239 196.712)'
        fill='var(--white)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 356.712 199.585)'
        fill='var(--white)'
      />
      <g filter='url(#filter18_f_3383_10233)'>
        <rect
          width='3.7195'
          height='1.24019'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 347.537 193.287)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter19_f_3383_10233)'>
        <rect
          width='4.54605'
          height='1.24019'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 353.586 194.646)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter20_f_3383_10233)'>
        <rect
          width='1.65324'
          height='0.414023'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 353.741 205.273)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter21_f_3383_10233)'>
        <rect
          width='2.06639'
          height='2.48039'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 351.321 204.729)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter22_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 348.49 207.906)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter23_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 346.927 205.437)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter24_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 345.273 203.37)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter25_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 356.391 202.903)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter26_f_3383_10233)'>
        <rect
          width='2.47967'
          height='6.20097'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 344.665 194.76)'
          fill='#A60400'
        />
      </g>
      <rect
        width='4.54605'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 354.129 192.225)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 358.112 195.239)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 351.257 193.699)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 345.208 192.339)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 343.306 200.81)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 344.779 203.683)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 346.342 206.153)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 348.309 208.713)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 350.778 207.149)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 353.247 205.586)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 355.806 203.619)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='6.61437'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 342.246 194.216)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='6.61437'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 359.584 198.112)'
        fill='var(--black)'
      />
      <rect
        width='4.54605'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 347.677 190.776)'
        fill='var(--black)'
      />
      <path
        d='M328.587 346.062L324.152 345.066L323.699 347.083L321.279 346.539L321.732 344.522L318.103 343.707L317.65 345.723L315.231 345.18L313.872 351.23L316.292 351.774L315.748 354.194L317.764 354.647L317.312 356.664L319.328 357.117L318.875 359.133L320.891 359.587L321.344 357.57L323.36 358.023L323.813 356.006L325.829 356.459L326.372 354.039L328.792 354.583L329.154 352.969L326.735 352.426L327.233 350.207L325.217 349.754L325.806 347.132L328.225 347.676L328.587 346.062Z'
        fill='var(--red)'
      />
      <path d='M330.15 348.532L329.698 350.549L327.681 350.096L328.134 348.079L330.15 348.532Z' fill='var(--red)' />
      <rect
        width='2.47967'
        height='2.89379'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 325.806 347.132)'
        fill='var(--white)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 327.278 350.005)'
        fill='var(--white)'
      />
      <g filter='url(#filter27_f_3383_10233)'>
        <rect
          width='3.7195'
          height='1.24019'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 318.103 343.707)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter28_f_3383_10233)'>
        <rect
          width='4.54605'
          height='1.24019'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 324.152 345.065)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter29_f_3383_10233)'>
        <rect
          width='1.65324'
          height='0.414023'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 324.307 355.693)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter30_f_3383_10233)'>
        <rect
          width='2.06639'
          height='2.48039'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.887 355.15)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter31_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 319.056 358.327)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter32_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 317.493 355.857)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter33_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.839 353.791)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter34_f_3383_10233)'>
        <rect
          width='2.06639'
          height='0.826796'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 326.957 353.323)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter35_f_3383_10233)'>
        <rect
          width='2.47967'
          height='6.20097'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.231 345.18)'
          fill='#A60400'
        />
      </g>
      <rect
        width='4.54605'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 324.695 342.646)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 328.678 345.659)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.823 344.119)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.775 342.76)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 313.872 351.23)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 315.345 354.104)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 316.908 356.573)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 318.875 359.134)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 321.344 357.57)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 323.813 356.006)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 326.372 354.039)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='6.61437'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 312.812 344.637)'
        fill='var(--black)'
      />
      <rect
        width='2.47967'
        height='6.61437'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 330.15 348.532)'
        fill='var(--black)'
      />
      <rect
        width='4.54605'
        height='2.48039'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 318.244 341.196)'
        fill='var(--black)'
      />
      <path
        d='M144.961 261.031L141.137 260.172L140.746 261.91L138.661 261.442L139.051 259.703L135.922 259L135.532 260.739L133.446 260.27L132.275 265.486L134.36 265.955L133.892 268.041L135.63 268.432L135.24 270.171L136.978 270.561L136.587 272.3L138.326 272.691L138.716 270.952L140.454 271.343L140.845 269.604L142.583 269.994L143.051 267.908L145.137 268.377L145.45 266.986L143.364 266.517L143.793 264.604L142.055 264.214L142.563 261.953L144.649 262.422L144.961 261.031Z'
        fill='var(--red)'
      />
      <path d='M146.309 263.16L145.918 264.899L144.18 264.508L144.57 262.77L146.309 263.16Z' fill='var(--red)' />
      <rect
        width='2.13785'
        height='2.49488'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 142.563 261.954)'
        fill='var(--white)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 143.832 264.431)'
        fill='var(--white)'
      />
      <g filter='url(#filter36_f_3383_10233)'>
        <rect
          width='3.20677'
          height='1.06923'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 135.922 259)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter37_f_3383_10233)'>
        <rect
          width='3.91939'
          height='1.06923'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 141.137 260.171)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter38_f_3383_10233)'>
        <rect
          width='1.42534'
          height='0.35695'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 141.27 269.334)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter39_f_3383_10233)'>
        <rect
          width='1.78154'
          height='2.13847'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 139.185 268.866)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter40_f_3383_10233)'>
        <rect
          width='1.78154'
          height='0.712823'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 136.744 271.604)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter41_f_3383_10233)'>
        <rect
          width='1.78154'
          height='0.712823'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 135.396 269.475)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter42_f_3383_10233)'>
        <rect
          width='1.78154'
          height='0.712823'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 133.97 267.694)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter43_f_3383_10233)'>
        <rect
          width='1.78154'
          height='0.712823'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 143.555 267.291)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter44_f_3383_10233)'>
        <rect
          width='2.13785'
          height='5.34617'
          transform='matrix(0.975672 0.219237 -0.219103 0.975702 133.446 260.27)'
          fill='#A60400'
        />
      </g>
      <rect
        width='3.91939'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 141.605 258.085)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 145.039 260.684)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 139.129 259.355)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 133.915 258.184)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 132.275 265.486)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 133.544 267.963)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 134.892 270.093)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 136.587 272.3)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 138.716 270.952)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 140.845 269.604)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 143.051 267.908)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='5.70258'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 131.36 259.802)'
        fill='var(--black)'
      />
      <rect
        width='2.13785'
        height='5.70258'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 146.309 263.161)'
        fill='var(--black)'
      />
      <rect
        width='3.91939'
        height='2.13847'
        transform='matrix(0.975672 0.219237 -0.219103 0.975702 136.043 256.835)'
        fill='var(--black)'
      />
      <path
        d='M64.8637 303.131L60.161 306.95L61.896 309.088L59.3309 311.17L57.5959 309.032L53.7482 312.156L55.4832 314.294L52.9181 316.377L58.123 322.792L60.6881 320.709L62.77 323.275L64.9076 321.54L66.6426 323.678L68.7802 321.942L70.5152 324.081L72.6527 322.345L70.9178 320.207L73.0554 318.471L71.3204 316.333L73.458 314.598L71.376 312.032L73.9412 309.949L72.5532 308.238L69.9881 310.321L68.0796 307.969L65.942 309.704L63.6866 306.925L66.2517 304.842L64.8637 303.131Z'
        fill='var(--red)'
      />
      <path d='M68.7363 303.534L70.4712 305.672L68.3336 307.408L66.5987 305.27L68.7363 303.534Z' fill='var(--red)' />
      <rect
        width='3.30411'
        height='3.85505'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 63.6866 306.924)'
        fill='var(--white)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 67.9062 307.755)'
        fill='var(--white)'
      />
      <g filter='url(#filter45_f_3383_10233)'>
        <rect
          width='4.95616'
          height='1.65216'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 53.748 312.155)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter46_f_3383_10233)'>
        <rect
          width='6.05753'
          height='1.65216'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 60.1611 306.949)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter47_f_3383_10233)'>
        <rect
          width='2.20274'
          height='0.550721'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 71.4012 315.558)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter48_f_3383_10233)'>
        <rect
          width='2.75342'
          height='3.30432'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 68.8358 317.641)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter49_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 69.821 323.225)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter50_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 65.9483 322.822)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter51_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 62.423 322.848)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter52_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 71.1094 310.829)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter53_f_3383_10233)'>
        <rect
          width='3.30411'
          height='8.26081'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 52.9181 316.377)'
          fill='#A60400'
        />
      </g>
      <rect
        width='6.05753'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 58.0788 304.383)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 64.5166 302.704)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 57.2488 308.604)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 50.8361 313.811)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 58.123 322.792)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 62.3425 323.622)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 66.2151 324.025)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 70.5149 324.081)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 70.9178 320.207)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 71.3204 316.333)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 71.3762 312.032)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='8.81153'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 50.3531 318.459)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='8.81153'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 68.7361 303.534)'
        fill='var(--black)'
      />
      <rect
        width='6.05753'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.2387 309.937)'
        fill='var(--black)'
      />
      <path
        d='M45.3277 166.869L40.625 170.687L42.36 172.826L39.7949 174.908L38.0599 172.77L34.2123 175.894L35.9472 178.032L33.3821 180.115L38.587 186.53L41.1521 184.447L43.2341 187.013L45.3717 185.277L47.1066 187.416L49.2442 185.68L50.9792 187.819L53.1168 186.083L51.3818 183.945L53.5194 182.209L51.7844 180.071L53.922 178.335L51.8401 175.769L54.4052 173.687L53.0172 171.976L50.4521 174.059L48.5436 171.707L46.406 173.442L44.1506 170.662L46.7157 168.58L45.3277 166.869Z'
        fill='var(--red)'
      />
      <path d='M49.2003 167.272L50.9353 169.41L48.7977 171.146L47.0627 169.008L49.2003 167.272Z' fill='var(--red)' />
      <rect
        width='3.30411'
        height='3.85505'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 44.1507 170.662)'
        fill='var(--white)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 48.3702 171.493)'
        fill='var(--white)'
      />
      <g filter='url(#filter54_f_3383_10233)'>
        <rect
          width='4.95616'
          height='1.65216'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 34.212 175.893)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter55_f_3383_10233)'>
        <rect
          width='6.05753'
          height='1.65216'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 40.6251 170.687)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter56_f_3383_10233)'>
        <rect
          width='2.20274'
          height='0.550721'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.8652 179.296)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter57_f_3383_10233)'>
        <rect
          width='2.75342'
          height='3.30432'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 49.2998 181.378)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter58_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 50.285 186.962)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter59_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 46.4123 186.56)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter60_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 42.8871 186.585)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter61_f_3383_10233)'>
        <rect
          width='2.75342'
          height='1.10144'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.5734 174.567)'
          fill='#A60400'
        />
      </g>
      <g filter='url(#filter62_f_3383_10233)'>
        <rect
          width='3.30411'
          height='8.26081'
          transform='matrix(0.77634 -0.630314 0.63007 0.776539 33.3821 180.115)'
          fill='#A60400'
        />
      </g>
      <rect
        width='6.05753'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 38.5428 168.121)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 44.9806 166.441)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 37.7128 172.342)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 31.3001 177.548)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 38.587 186.529)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 42.8065 187.359)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 46.6791 187.763)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 50.9789 187.818)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.3818 183.944)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.7844 180.071)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 51.8402 175.77)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='8.81153'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 30.8171 182.197)'
        fill='var(--black)'
      />
      <rect
        width='3.30411'
        height='8.81153'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 49.2001 167.271)'
        fill='var(--black)'
      />
      <rect
        width='6.05753'
        height='3.30432'
        transform='matrix(0.77634 -0.630314 0.63007 0.776539 31.7027 173.675)'
        fill='var(--black)'
      />
      <defs>
        <filter
          id='filter0_f_3383_10233'
          x='60.7271'
          y='59.3838'
          width='10.371'
          height='8.7128'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter1_f_3383_10233'
          x='68.2536'
          y='55.5552'
          width='11.3745'
          height='9.16299'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter2_f_3383_10233'
          x='78.4913'
          y='69.9261'
          width='4.21674'
          height='3.38748'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter3_f_3383_10233'
          x='75.4807'
          y='71.0526'
          width='5.84351'
          height='6.12137'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter4_f_3383_10233'
          x='74.9984'
          y='76.6966'
          width='4.94284'
          height='4.11356'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter5_f_3383_10233'
          x='71.3637'
          y='75.3133'
          width='4.94284'
          height='4.11356'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter6_f_3383_10233'
          x='67.9543'
          y='74.4315'
          width='4.94284'
          height='4.11356'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter7_f_3383_10233'
          x='79.424'
          y='65.0619'
          width='4.94284'
          height='4.11356'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.495918' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter8_f_3383_10233'
          x='58.8424'
          y='63.9209'
          width='11.5677'
          height='14.06'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.2949' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter9_f_3383_10233'
          x='315.177'
          y='48.0469'
          width='15.2078'
          height='11.5482'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter10_f_3383_10233'
          x='326.98'
          y='50.6993'
          width='16.7816'
          height='11.9022'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter11_f_3383_10233'
          x='329.98'
          y='73.7823'
          width='6.23325'
          height='4.40357'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter12_f_3383_10233'
          x='324.374'
          y='72.7213'
          width='7.90395'
          height='8.51587'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter13_f_3383_10233'
          x='319.556'
          y='78.921'
          width='7.1969'
          height='5.36743'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter14_f_3383_10233'
          x='316.506'
          y='74.1017'
          width='7.1969'
          height='5.36743'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter15_f_3383_10233'
          x='313.278'
          y='70.069'
          width='7.1969'
          height='5.36743'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter16_f_3383_10233'
          x='334.975'
          y='69.1564'
          width='7.1969'
          height='5.36743'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.727234' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter17_f_3383_10233'
          x='307.451'
          y='50.9215'
          width='14.9683'
          height='20.4637'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.89889' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter18_f_3383_10233'
          x='345.319'
          y='191.341'
          width='7.7929'
          height='5.91756'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter19_f_3383_10233'
          x='351.368'
          y='192.699'
          width='8.59935'
          height='6.09871'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter20_f_3383_10233'
          x='352.904'
          y='204.528'
          width='3.19435'
          height='2.25722'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter21_f_3383_10233'
          x='350.032'
          y='203.984'
          width='4.05019'
          height='4.36366'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter22_f_3383_10233'
          x='347.563'
          y='207.161'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter23_f_3383_10233'
          x='346'
          y='204.691'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter24_f_3383_10233'
          x='344.346'
          y='202.625'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter25_f_3383_10233'
          x='355.464'
          y='202.158'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter26_f_3383_10233'
          x='341.36'
          y='192.814'
          width='7.67016'
          height='10.4859'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter27_f_3383_10233'
          x='315.886'
          y='341.761'
          width='7.79291'
          height='5.91756'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter28_f_3383_10233'
          x='321.934'
          y='343.119'
          width='8.59935'
          height='6.09871'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter29_f_3383_10233'
          x='323.471'
          y='354.948'
          width='3.19435'
          height='2.25722'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter30_f_3383_10233'
          x='320.599'
          y='354.405'
          width='4.05019'
          height='4.36366'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter31_f_3383_10233'
          x='318.13'
          y='357.581'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter32_f_3383_10233'
          x='316.566'
          y='355.112'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter33_f_3383_10233'
          x='314.912'
          y='353.045'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter34_f_3383_10233'
          x='326.03'
          y='352.578'
          width='3.68788'
          height='2.75038'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.372655' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter35_f_3383_10233'
          x='311.926'
          y='343.234'
          width='7.67015'
          height='10.4859'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.973042' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter36_f_3383_10233'
          x='134.01'
          y='257.322'
          width='6.71868'
          height='5.10173'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter37_f_3383_10233'
          x='139.225'
          y='258.494'
          width='7.41396'
          height='5.25798'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter38_f_3383_10233'
          x='140.55'
          y='268.692'
          width='2.75401'
          height='1.94578'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter39_f_3383_10233'
          x='138.074'
          y='268.223'
          width='3.49186'
          height='3.76219'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter40_f_3383_10233'
          x='135.945'
          y='270.962'
          width='3.17952'
          height='2.37108'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter41_f_3383_10233'
          x='134.597'
          y='268.833'
          width='3.17952'
          height='2.37108'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter42_f_3383_10233'
          x='133.171'
          y='267.051'
          width='3.17952'
          height='2.37108'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter43_f_3383_10233'
          x='142.757'
          y='266.648'
          width='3.17952'
          height='2.37108'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.321285' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter44_f_3383_10233'
          x='130.597'
          y='258.592'
          width='6.61284'
          height='9.0407'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.83891' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter45_f_3383_10233'
          x='51.1552'
          y='306.438'
          width='10.0743'
          height='9.59288'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter46_f_3383_10233'
          x='57.5682'
          y='300.538'
          width='10.9293'
          height='10.2872'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter47_f_3383_10233'
          x='70.4082'
          y='313.177'
          width='4.04306'
          height='3.80191'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter48_f_3383_10233'
          x='67.8428'
          y='314.912'
          width='6.20554'
          height='6.28727'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter49_f_3383_10233'
          x='68.828'
          y='320.496'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter50_f_3383_10233'
          x='64.9553'
          y='320.094'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter51_f_3383_10233'
          x='61.43'
          y='320.119'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter52_f_3383_10233'
          x='70.1164'
          y='308.101'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter53_f_3383_10233'
          x='50.3252'
          y='311.702'
          width='12.9556'
          height='13.6832'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter54_f_3383_10233'
          x='31.6192'
          y='170.176'
          width='10.0743'
          height='9.59288'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter55_f_3383_10233'
          x='38.0322'
          y='164.276'
          width='10.9293'
          height='10.2872'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter56_f_3383_10233'
          x='50.8722'
          y='176.915'
          width='4.04306'
          height='3.80191'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter57_f_3383_10233'
          x='48.3068'
          y='178.65'
          width='6.20554'
          height='6.28727'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter58_f_3383_10233'
          x='49.292'
          y='184.234'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter59_f_3383_10233'
          x='45.4193'
          y='183.832'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter60_f_3383_10233'
          x='41.8941'
          y='183.857'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter61_f_3383_10233'
          x='50.5804'
          y='171.839'
          width='4.81757'
          height='4.57682'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='0.496499' result='effect1_foregroundBlur_3383_10233' />
        </filter>
        <filter
          id='filter62_f_3383_10233'
          x='30.7893'
          y='175.439'
          width='12.9556'
          height='13.6832'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='1.29641' result='effect1_foregroundBlur_3383_10233' />
        </filter>
      </defs>
    </svg>
  )
}
